// extracted by mini-css-extract-plugin
module.exports = {"container":"NoAccess_container__2uRg0","component":"NoAccess_component__2L2X0","card":"NoAccess_card__2dAWG","title":"NoAccess_title__3Okdt","hint":"NoAccess_hint__1swrp"};